// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-zBzUi";
var _5 = "wrapper--chBW";
var _6 = "switch__root-19Y5Z";
var _7 = "label-3LICO";
var _8 = "description-3MNem";
var _9 = "control-1j2zl";
var _a = "control__label-2tmhf";
var _b = "input-14MZf";
var _c = "collapse-2YXQ9";
var _d = "collapse__icon-Ryb19";
var _e = "collapse__content-2xI-h";
var _f = "collapse__contentInfo-XEotK";
var _10 = "collapse__title-1a6mw";
var _11 = "collapse__titleWrapper-2-haf";
var _12 = "collapse__titleIcon-3aB9F";
var _13 = "collapse__format-TPVP_";
var _14 = "collapse__error-28U2b";
var _15 = "collapse__files-m7NZT";
var _16 = "collapse__filesItem-M0eHd";
var _17 = "collapse__filesItemSize-3daKT";
var _18 = "collapse__filesItemIcon-jtcwS";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "wrapper", _6 as "switch__root", _7 as "label", _8 as "description", _9 as "control", _a as "control__label", _b as "input", _c as "collapse", _d as "collapse__icon", _e as "collapse__content", _f as "collapse__contentInfo", _10 as "collapse__title", _11 as "collapse__titleWrapper", _12 as "collapse__titleIcon", _13 as "collapse__format", _14 as "collapse__error", _15 as "collapse__files", _16 as "collapse__filesItem", _17 as "collapse__filesItemSize", _18 as "collapse__filesItemIcon" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "wrapper": _5, "switch__root": _6, "label": _7, "description": _8, "control": _9, "control__label": _a, "input": _b, "collapse": _c, "collapse__icon": _d, "collapse__content": _e, "collapse__contentInfo": _f, "collapse__title": _10, "collapse__titleWrapper": _11, "collapse__titleIcon": _12, "collapse__format": _13, "collapse__error": _14, "collapse__files": _15, "collapse__filesItem": _16, "collapse__filesItemSize": _17, "collapse__filesItemIcon": _18 }
